module.exports = __webpack_public_path__ + "static/media/logo-suncast.2f88aa37.png";